<template>
  <div>
    <!-- Toolbar -->
    <div class="toolbar d-flex flex-wrap justify-content-end mb-2">
      <div class="d-flex flex-wrap justify-content-center justify-content-md-start">
        <!-- <div class="input-group align-self-center mr-2 mt-2 mt-md-0 mb-2 mb-md-0"
             style="width: 22rem">

          <input type="text"
                 class="form-control form-control-sm flex-1"
                 :placeholder="$t('search.search_keyword')"
                 v-model.trim="search.keyword"
                 style="width: 8rem"
                 @keydown.enter="searchShippers()" />
          <div class="input-group-append">
            <button class="btn btn-outline-success btn-sm"
                    type="button"
                    @click="searchShippers()">
              <i class="fal fa-search"></i>
            </button>
          </div>
        </div> -->

        <button variant="success"
                data-toggle="modal"
                data-target="#shipperModal"
                class="btn btn-success btn-sm"
                @click="handleAddForm()">
          <i class="fal fa-plus-circle mr-1"></i>
          สร้างลูกค้าใหม่
        </button>
      </div>
    </div>

    <div v-if="paginatedShippers && !loading">
      <div v-if="paginatedShippers.length"
           class="table-responsive">
        <table class="table _datatable shippers-table --very-small-height">
          <thead>
            <tr>
              <th>ชื่อผู้รับ</th>
              <th>เบอร์โทรศัพท์	</th>
              <th>บัตรประจำตัวประชาชน</th>
              <th>ที่อยู่ผู้รับ</th>
              <th>อำเภอ/เขต</th>
              <th>ตำบล/แขวง</th>
              <th>จังหวัด</th>
              <th>รหัสปณ.</th>
              <th>วันที่</th>
              <th></th>
            </tr>
          </thead>
          <tbody :class="{ '--loading': miniLoading }">
            <tr v-for="(row, index) in paginatedShippers"
                :key="index">

              <td class="--width-md">
                {{ row.name }}
              </td>

              <td class="--width-md">
                {{ row.phoneNo }}
              </td>

              <td class="--width-md">
                {{ row.idCard }}
              </td>

              <td>
                {{ row.addr }}
              </td>

              <td>
                {{ row.dist }}
              </td>

              <td>
                {{ row.subDist }}
              </td>

              <td>
                {{ row.prov }}
              </td>

              <td>
                {{ row.zip }}
              </td>

              <td v-html="tdHtml('createdAtDate', row.createdAt)"></td>

              <td>
                <Button variant="link"
                        size="sm"
                        custom_class="mr-2 p-0 text-color-5"
                        id="btn-action-edit"
                        @click="editItem(row)">
                  <i class="fal fa-edit"></i>
                </Button>

                <Button variant="link"
                        custom_class="p-0 text-color-5 mr-2"
                        size="sm"
                        id="btn-action-delete"
                        @click="deleteItem(row)">
                  <i class="fal fa-times-circle"></i>
                </Button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between">
          <div>
            <select class="form-control"
                    v-model="perPage"
                    @change="handlePerPageChange()">
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="300">300</option>
              <option value="500">500</option>
            </select>
          </div>

          <div class="d-flex">
            <p class="align-self-center mr-2 text-color-4">
              หน้าที่ {{ page }}
            </p>

            <div class="btn-group"
                 role="group">
              <Button type="button"
                      variant="outline-primary"
                      size="lg"
                      id="btn-paginate-prev"
                      @click="paginate(false)"
                      :disabled="page === 1">
                <i class="fal fa-long-arrow-left"></i>
              </Button>

              <Button type="button"
                      variant="outline-primary"
                      size="lg"
                      id="btn-paginate-prev"
                      @click="paginate(true)"
                      :disabled="page === lastPage"
                      :loading="miniLoading">
                <i class="fal fa-long-arrow-right"></i>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!paginatedShippers.length"
           class="alert alert-warning mt-5 mb-5">
        No Shippers found
      </div>
    </div>

    <div v-else>
      <Spinner :variant="'primary'"
               size="md" />
    </div>

    <Modal id="shipperModal">
      <template slot="header">
        <h5 class="modal-title">
          <i class="mr-2 fal fa-users"></i>
          <span v-if="formMode === 0">สร้างลูกค้าใหม่</span>
          <span v-else-if="formMode === 1">สร้างลูกค้าใหม่</span>
        </h5>
      </template>

      <template slot="body">
        <ValidationObserver v-slot="{ invalid }">
          <form ref="shipperForm"
                @submit.prevent="handleFormSubmit">

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">{{ $t('general.name') }}</p>
              </div>
              <div class="col-9">
                <TextBox type="text"
                         size="sm"
                         id="shop-name"
                         :placeholder="$t('general.name')"
                         rules="required"
                         v-model="shipperForm.name" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">{{ $t('general.phone') }}</p>
              </div>
              <div class="col-9">
                <PhoneNumber :placeholder="$t('general.phone')"
                             id="shop-phone-number"
                             rules="required"
                             :value="shipperForm.phoneNo"
                             v-model="shipperForm.phoneNo" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">บัตรประจำตัวประชาชน</p>
              </div>
              <div class="col-9">
                <VatField id="id-card-no"
                          v-model="shipperForm.idCard"
                          rules="vat|required" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">เบอร์โทรศัพท์ <br> Wallet@Post</p>
              </div>
              <div class="col-9">
                <WalletId placeholder="เบอร์โทรศัพท์ Wallet@Post"
                          id="shipper-wallet-id"
                          :value="shipperForm.walletId"
                          v-model="shipperForm.walletId" />
              </div>
            </div>



            <SmartAddress :label="$t('general.address.address')"
                          placeholder="Address"
                          id="shipper-address"
                          rules="required"
                          :horizontal="true"
                          :value="{
                  addr: shipperForm.addr,
                  dist: shipperForm.dist,
                  subDist: shipperForm.subDist,
                  prov: shipperForm.prov,
                  zip: shipperForm.zip,
                }"
                          @change="handleAddressChange" />

            <div class="d-flex justify-content-center">
              <Button custom_class="pl-4 pr-4 btn-block"
                      type="submit"
                      id="btn-add-update-shop"
                      size="md"
                      :disabled="invalid || formLoading"
                      variant="primary"
                      :loading="formLoading">
                <span v-if="formMode === 0">สร้างลูกค้า</span>
                <span v-if="formMode === 1">ยืนยันการแก้ไข</span>
              </Button>
            </div>
          </form>
        </ValidationObserver>
      </template>
    </Modal>

  </div>
</template>

<script>
import TextBox from "@/components/core/TextBox";
import NumberField from "@/components/core/TextBox";
import Modal from "@/components/core/Modal";
import Button from "@/components/core/Button";
import PhoneNumber from "@/components/derived/PhoneNumber";
import WalletId from "@/components/derived/WalletId";
import { Alert } from "@/helpers/alert";
import Spinner from "@/components/core/Spinner";
import Tabs from "@/components/core/Tabs";
import CopyButton from "@/components/derived/CopyButton";
import _ from "lodash";
import Select from "@/components/core/Select";
import { FILTERS } from "@/helpers/filters";
import VatField from "@/components/derived/VatField";
import SmartAddress from "@/components/derived/SmartAddress";

export default {
  name: "ShippersTable",
  components: {
    TextBox,
    NumberField,
    Modal,
    Button,
    Spinner,
    Tabs,
    Select,
    CopyButton,
    PhoneNumber,
    WalletId,
    VatField,
    SmartAddress
  },
  data() {
    return {
      shipperRows: null,
      shipperCounts: null,
      LastEvaluatedKey: null,
      paginatedShippers: [],

      loading: false,
      miniLoading: false,
      modalLoading: false,
      formLoading: false,

      formMode: 0,
      shipperForm: null,

      page: 1,
      perPage: 100,
      lastPage: null,

      search: {
        column: "",
        keyword: null,
      },
    };
  },

  created() {
    this.initForm();
  },

  async mounted() {
    await this.fetchShippers()

    if (this.$route.query.shipperId) {
      const id = this.$route.query.shipperId.split("__")[0]
      const shipper = this.shipperRows.find(s => s.id === id)
      if (shipper !== -1) this.editItem(shipper)
    }
  },

  methods: {
    handleAddressChange({ addr, dist, subDist, prov, zip }) {
      this.shipperForm.addr = addr;
      this.shipperForm.dist = dist;
      this.shipperForm.subDist = subDist;
      this.shipperForm.prov = prov;
      this.shipperForm.zip = zip;
    },

    tdHtml(type, value) {
      const types = {
        createdAtDate: (value) => {
          return FILTERS.formatDate(value);
        }
      };
      return types[type] ? types[type](value) : value;
    },

    paginate(forward = true) {
      if (forward) {
        if (!(this.lastPage && this.page === this.lastPage))
          this.page = this.page + 1;
      } else {
        this.page = Math.max(--this.page, 1);
      }
      this.handlePageChange();
    },

    async fetchShippers(firstPage = true, _callback) {
      if (firstPage) this.loading = true;
      else this.miniLoading = true;

      const { status, data } = await this.$store.dispatch("shippers/fetchShippers", {
        params: {
          ExclusiveStartKey: !firstPage ? JSON.stringify(this.LastEvaluatedKey) : null,
          perPage: this.perPage
        }
      });

      if (status) {
        this.LastEvaluatedKey = data.LastEvaluatedKey;

        if (firstPage) {
          this.shipperRows = data.shippers.map(s => {
            return {
              ...s,
              walletId: s.walletId ? { data: s.walletId, error: null } : null
            }
          });
          this.page = 1;
          this.lastPage = null;
        } else {
          this.shipperRows = this.shipperRows.concat(data.shippers);
        }

        // LOGIC: check from counter
        this.lastPage = data.LastEvaluatedKey ? false : true;

        if (this.shipperRows.length) {
          this.handlePageChange();
        } else {
          this.loading = false;
          this.miniLoading = false;
        }
      }

      if (firstPage) this.loading = false;
      else this.miniLoading = false;

      if (_callback) _callback();
    },

    searchShippers() {
      let searchData = {
        ...this.search,
        status: this.currentTabStatus
      };
      this.loading = true;
      this.$store.dispatch("shippers/searchShippers", {
        ...searchData,
        callback: (status, data) => {
          this.shipperRows = data.results.map((d) => {
            return {
              id: d.id,
              trackingNo: d.trackingNo,
              status: d.status,
              shippingMethod: d.shippingMethod,
              shipperCode: d.shipperCode,
              custName: d.customerName,
              custPhone: d.phoneNo,
              createdAt: d.createdAt,
              codAmount: d.codAmount,
              shopName: d.shopName,
              codPaid: d.codPaid,
              printed: d.printCount && d.printCount > 0,
            };
          });
          this.page = 1;
          this.lastPage = null;
          this.LastEvaluatedKey = null;
          this.handlePageChange();
          this.loading = false;
        },
      });
    },

    handlePageChange() {
      let startIndex = (this.page - 1) * this.perPage;
      let endIndex = this.perPage * this.page - 1;

      // check if it needs data to load from server
      if (
        this.shipperRows.length <= endIndex &&
        this.LastEvaluatedKey &&
        this.page != this.lastPage
      ) {
        this.fetchShippers(this.currentTabStatus, false, () => {
          this.paginatedShippers = this.shipperRows.slice(startIndex, endIndex + 1);
        });
      } else {
        this.paginatedShippers = this.shipperRows.slice(startIndex, endIndex + 1);
      }

      //handle empty page
      if (this.paginatedShippers.length === 0) {
        this.page--;
        this.lastPage = this.page;
        this.handlePageChange();
        this.LastEvaluatedKey = null;
      }
    },

    handlePerPageChange() {
      this.page = 1;
      this.handlePageChange();
    },

    handleAddForm() {
      this.formMode = 0;
      this.initForm();
    },

    initForm() {
      this.shipperForm = {
        name: null,
        phoneNo: null,
        idCard: null,
        addr: null,
        dist: null,
        subDist: null,
        prov: null,
        zip: null,
      };
    },

    deleteItem(shipper) {
      Alert(
        "Delete Shipper",
        "Are you sure you want to delete this shipper?",
        null,
        async () => {
          this.miniLoading = true;
          const { status } = await this.$store.dispatch("shippers/deleteShipper", { id: `${shipper.id}__${shipper.createdAt}` });
          if (status) {
            let index = this.paginatedShippers.findIndex(s => s.id === shipper.id)
            if (index !== -1) {
              this.paginatedShippers.splice(index, 1)
            }
          }
          this.miniLoading = false;
        }
      );
    },

    editItem(shipper) {
      this.shipperForm = JSON.parse(JSON.stringify(shipper));
      this.formMode = 1;
      $("#shipperModal").modal("show");
    },

    async handleFormSubmit() {
      this.formLoading = true;
      if (this.formMode === 0) {
        const { status, data } = await this.$store.dispatch("shippers/createShipper", {
          shipper: { ...this.shipperForm, walletId: this.shipperForm.walletId ? this.shipperForm.walletId.data : null }
        })
        if (status) {
          this.paginatedShippers.unshift(data)
          $("#shipperModal").modal("hide");
        }
      } else {
        const { status } = await this.$store.dispatch("shippers/updateShipper", {
          id: `${this.shipperForm.id}__${this.shipperForm.createdAt}`,
          shipper: {
            name: this.shipperForm.name,
            phoneNo: this.shipperForm.phoneNo,
            idCard: this.shipperForm.idCard,
            addr: this.shipperForm.addr,
            dist: this.shipperForm.dist,
            subDist: this.shipperForm.subDist,
            prov: this.shipperForm.prov,
            zip: this.shipperForm.zip,
            walletId: this.shipperForm.walletId ? this.shipperForm.walletId.data : null
          }
        })
        if (status) {
          let index = this.paginatedShippers.findIndex(s => s.id === this.shipperForm.id)
          if (index !== -1) {
            const _shippers = JSON.parse(JSON.stringify(this.paginatedShippers))
            _shippers[index] = JSON.parse(JSON.stringify(this.shipperForm))
            this.paginatedShippers = _shippers
          }
          $("#shipperModal").modal("hide");
        }
      }

      this.formLoading = false;
      // await this.fetchShippers();
    }
  }
};
</script>